/*
 * pdp-reason-card.js — HAM-4105
 * PDP 上部「買う理由カード」の可視化と、PDP のスクロール深度を PostHog へ送る。
 * PostHog スニペットは layout/theme.liquid で {%- unless Shopify.designMode -%} に
 * 囲われているため、テーマエディタ内では capture が存在せず全て黙って no-op になる。
 */
(function () {
  var SCROLL_MILESTONES = [25, 50, 75, 100];

  // theme.liquid 側で data-template-name を渡す。defer script でも currentScript は有効。
  var currentScript = document.currentScript;
  var TEMPLATE_NAME = (currentScript && currentScript.dataset.templateName) || null;

  function capture(eventName, props) {
    try {
      if (!window.posthog || typeof window.posthog.capture !== 'function') return;
      window.posthog.capture(eventName, props || {});
    } catch (e) {
      console.warn('[PostHog] PDP reason card capture failed:', e);
    }
  }

  function templateName() {
    return TEMPLATE_NAME;
  }

  function observeReasonCard() {
    var card = document.querySelector('[data-reason-card]');
    if (!card) return;

    var baseProps = {
      product_handle: card.dataset.productHandle || null,
      section_id: card.dataset.sectionId || null,
      template_name: templateName(),
      instrumentation_source: card.dataset.instrumentationSource || 'theme_pdp_reason_card'
    };

    if (typeof window.IntersectionObserver !== 'function') {
      // 非対応ブラウザでは可視判定を諦め、存在のみを 1 回記録する
      capture('pdp_reason_card_view', baseProps);
      return;
    }

    var fired = false;
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting || fired) continue;
          fired = true;
          observer.disconnect();
          capture('pdp_reason_card_view', baseProps);
          return;
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(card);
  }

  function trackScrollDepth() {
    var handle = null;
    var card = document.querySelector('[data-reason-card]');
    if (card) handle = card.dataset.productHandle || null;

    var reached = {};
    var ticking = false;

    function measure() {
      ticking = false;
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var percent = ((window.scrollY || doc.scrollTop || 0) / scrollable) * 100;

      for (var i = 0; i < SCROLL_MILESTONES.length; i++) {
        var milestone = SCROLL_MILESTONES[i];
        if (percent < milestone || reached[milestone]) continue;
        reached[milestone] = true;
        capture('pdp_scroll_depth', {
          depth_percent: milestone,
          product_handle: handle,
          template_name: templateName(),
          instrumentation_source: 'theme_pdp_reason_card'
        });
      }

      if (reached[100]) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }

  function init() {
    observeReasonCard();
    trackScrollDepth();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
